var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"xskCascader"}},[_c('el-cascader',{staticClass:"cascader",attrs:{"options":_vm.options,"props":_vm.props,"show-all-levels":_vm.is_levels,"clearable":""},on:{"change":_vm.confirm},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }